/**
 * Nome de pessoa como se escreve em português: "ana lima" e "ANA LIMA"
 * viram "Ana Lima". Partículas ("de", "da", "dos", "e") ficam minúsculas,
 * exceto quando abrem o nome.
 *
 * Só mexe em nome escrito TODO minúsculo ou TODO maiúsculo. Quem digitou
 * "Sofia Mac Lean" ou "Ana McCarthy" escolheu cada maiúscula, e
 * padronizar isso seria corrigir uma pessoa sobre o próprio nome.
 */
const PARTICULAS = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'di', 'del', 'della', 'van', 'von']);

function capitalizar(palavra: string): string {
  // "maria-clara" → "Maria-Clara"; "d'ávila" → "D'Ávila".
  return palavra.replace(/(^|[-'])(\p{L})/gu, (_, sep: string, letra: string) => sep + letra.toLocaleUpperCase('pt-BR'));
}

export function normalizarNome(bruto: string): string {
  const nome = bruto.trim().replace(/\s+/g, ' ');
  if (!nome) return nome;
  const letras = nome.replace(/[^\p{L}]/gu, '');
  const todoMinusculo = letras === letras.toLocaleLowerCase('pt-BR');
  const todoMaiusculo = letras === letras.toLocaleUpperCase('pt-BR');
  if (!todoMinusculo && !todoMaiusculo) return nome;

  return nome
    .toLocaleLowerCase('pt-BR')
    .split(' ')
    .map((palavra, i) => (i > 0 && PARTICULAS.has(palavra) ? palavra : capitalizar(palavra)))
    .join(' ');
}
